import { ScreenWidthMinMedium, getGlobalClassNames } from '../../Styling';
var GlobalClassNames = {
  root: 'ms-Dialog'
};
export var getStyles = function (props) {
  var _a;
  var className = props.className,
    containerClassName = props.containerClassName,
    // eslint-disable-line deprecation/deprecation
    _b = props.dialogDefaultMinWidth,
    // eslint-disable-line deprecation/deprecation
    dialogDefaultMinWidth = _b === void 0 ? '288px' : _b,
    _c = props.dialogDefaultMaxWidth,
    dialogDefaultMaxWidth = _c === void 0 ? '340px' : _c,
    hidden = props.hidden,
    theme = props.theme;
  var classNames = getGlobalClassNames(GlobalClassNames, theme);
  return {
    root: [classNames.root, theme.fonts.medium, className],
    main: [{
      width: dialogDefaultMinWidth,
      outline: '3px solid transparent',
      selectors: (_a = {}, _a["@media (min-width: ".concat(ScreenWidthMinMedium, "px)")] = {
        width: 'auto',
        maxWidth: dialogDefaultMaxWidth,
        minWidth: dialogDefaultMinWidth
      }, _a)
    }, !hidden && {
      display: 'flex'
    }, containerClassName]
  };
};